import { useTranslation } from "react-i18next";
import CardComponent from "../../components/Card/Card";
import "./Cards.scss";

export default function Cards({ theme }) {
  const { t } = useTranslation();

  return (
    <div className="cards" id="experiences">
      <CardComponent
        competences={[
          t("cards.zenestya.competences.first"),
          t("cards.zenestya.competences.second"),
          t("cards.zenestya.competences.third"),
          t("cards.zenestya.competences.fourth"),
          t("cards.zenestya.competences.fifth"),
        ]}
        description={t("cards.zenestya.description")}
        img="./media/zenestya.png"
        secondTitle={t("cards.zenestya.secondTitle")}
        subtitle={t("cards.zenestya.subtitle")}
        technos="React Native, Expo, TypeScript, Supabase, PostgreSQL"
        title="Zenestya"
      />
      <CardComponent
        competences={[
          t("cards.lecouloir.competences.first"),
          t("cards.lecouloir.competences.second"),
          t("cards.lecouloir.competences.third"),
          t("cards.lecouloir.competences.fourth"),
        ]}
        description={t("cards.lecouloir.description")}
        img="./media/le-couloir.png"
        secondTitle={t("cards.lecouloir.secondTitle")}
        subtitle={t("cards.lecouloir.subtitle")}
        technos="Next.js, TypeScript, Tailwind CSS, Firebase"
        title="Le Couloir"
      />
      <CardComponent
        competences={[
          t("cards.cdiscount.competences.first"),
          t("cards.cdiscount.competences.second"),
          t("cards.cdiscount.competences.third"),
          t("cards.cdiscount.competences.fourth"),
          t("cards.cdiscount.competences.fifth"),
          t("cards.cdiscount.competences.sixth"),
        ]}
        description={t("cards.cdiscount.description")}
        img="./media/cdiscount.png"
        secondTitle={t("cards.cdiscount.secondTitle")}
        subtitle={t("cards.cdiscount.subtitle")}
        technos="React, React-admin, Jest, Azure, Material-ui, Jira, Github"
        title="Cdiscount / Cars"
      />
      <CardComponent
        competences={[
          t("cards.bison.competences.first"),
          t("cards.bison.competences.second"),
          t("cards.bison.competences.third"),
        ]}
        description={t("cards.bison.description")}
        img="./media/bison.png"
        secondTitle={t("cards.bison.secondTitle")}
        subtitle={t("cards.bison.subtitle")}
        technos="Vanilla javascript, Spip CMS, Jenkins, Jira, Github"
        title="Bison Futé"
      />
      <CardComponent
        competences={[
          t("cards.atlas.competences.first"),
          t("cards.atlas.competences.second"),
          t("cards.atlas.competences.third"),
        ]}
        description={t("cards.atlas.description")}
        img="./media/atlas.png"
        secondTitle={t("cards.atlas.secondTitle")}
        subtitle={t("cards.atlas.subtitle")}
        technos="React Native, Firebase, Ccode, App store connect, Google Play Console, Github"
        title="Atlas Sport"
      />
    </div>
  );
}
